export default "__VITE_ASSET__Cj_9XZC___"